import { render, staticRenderFns } from "./currency-timezones.vue?vue&type=template&id=0540c451&"
import script from "./currency-timezones.vue?vue&type=script&lang=js&"
export * from "./currency-timezones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports